import { IPlanPaymentType, IPlanType } from '../types';
import { firebase } from '../config/firebase.client';

export const createPayment = async (planId: IPlanType['ref']) => {
    const result = await firebase.callFunction('providersPagopar-createPayment', {
        planId,
    });


    return result;
};

export const checkPaymentStatus = async (paymentId: IPlanPaymentType['id']) => {
    const result = await firebase.callFunction('providersPagopar-checkPaymentStatus', {
        paymentId,
    });

    return result;
};